interface NavigationProps {
  scrolled: boolean;
}

export default function Navigation({ scrolled }: NavigationProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 cursor-pointer whitespace-nowrap" onClick={() => scrollToSection('home')}>
            <img 
              src="https://public.readdy.ai/ai/img_res/3d31840e-c611-420e-93b1-70e5b4525099.png" 
              alt="Articruz S A Logo" 
              className="h-10 w-10 object-contain"
            />
            <span className={`text-xl font-bold transition-colors ${scrolled ? 'text-gray-900' : 'text-white'}`}>
              Articruz S A
            </span>
          </div>
          
          <div className="flex items-center gap-8">
            <button
              onClick={() => scrollToSection('home')}
              className={`text-sm font-medium transition-colors hover:text-teal-500 whitespace-nowrap ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('products')}
              className={`text-sm font-medium transition-colors hover:text-teal-500 whitespace-nowrap ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Products
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`text-sm font-medium transition-colors hover:text-teal-500 whitespace-nowrap ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-medium transition-colors hover:text-teal-500 whitespace-nowrap ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Contact
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
